function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}

import { ScrollArea } from 'theme'
// js/common/behavior/vertical-scroll-area.js
var VerticalScrollArea = class extends HTMLElement {
  connectedCallback() {
    this._scrollArea = new ScrollArea(this, this._abortController);
  }
};
if (!window.customElements.get("vertical-scroll-area")) {
  window.customElements.define("vertical-scroll-area", VerticalScrollArea);
}

// js/common/behavior/vertical-scroll-progress.js
var VerticalScrollProgress = class extends HTMLElement {
  connectedCallback() {
    this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
    }
  }
  get scrolledElement() {
    return this._scrolledElement = this._scrolledElement || document.getElementById(this.getAttribute("observes"));
  }
  _updateScrollProgress() {
    const scrollTop = this.scrolledElement.scrollTop, scrollbarHeight = this.scrolledElement.clientHeight / this.scrolledElement.scrollHeight * this.scrolledElement.clientHeight, scrollProgress = (scrollTop / (this.scrolledElement.scrollHeight - this.scrolledElement.clientHeight)) * (this.scrolledElement.clientHeight - scrollbarHeight);
    this.style.setProperty("--scroll-bar-height", Math.max(0, scrollbarHeight).toFixed(2) + 'px');
    this.style.setProperty("--scroll-progress", scrollProgress + 'px');
  }
};
if (!window.customElements.get("vertical-scroll-progress")) {
  window.customElements.define("vertical-scroll-progress", VerticalScrollProgress);
}

// Reusable drag scroll handler
class DragScroll {
  constructor(selector) {
    setTimeout(() => document.querySelectorAll(selector).forEach(el => this.setup(el)), 100);
  }

  setup(el) {
    let state = { isDown: false, startX: 0, scrollLeft: 0 };

    const startDrag = (x) => {
      state.isDown = true;
      state.startX = x;
      state.scrollLeft = el.scrollLeft;
      el.classList.add('dragging');
    };

    const endDrag = () => {
      state.isDown = false;
      el.classList.remove('dragging');
    };

    const drag = (x, speed = 1) => {
      if (!state.isDown) return;
      console.log('move', state.scrollLeft - (x - state.startX) * speed);
      el.scrollLeft = state.scrollLeft - (x - state.startX) * speed;
    };

    // Mouse events
    el.addEventListener('mousedown', (e) => { e.preventDefault();startDrag(e.pageX); });
    el.addEventListener('mouseleave', endDrag);
    el.addEventListener('mouseup', endDrag);
    el.addEventListener('mousemove', (e) => { if (state.isDown) { e.preventDefault(); drag(e.pageX); }});

    // Touch events
    // el.addEventListener('touchstart', (e) => startDrag(e.touches[0].pageX), { passive: true });
    // el.addEventListener('touchend', endDrag);
    // el.addEventListener('touchmove', (e) => state.isDown && drag(e.touches[0].pageX, 1.5), { passive: true });

    // Prevent image drag
    el.addEventListener('dragstart', (e) => e.preventDefault());
  }
}

// Initialize
new DragScroll('.scroll-area, .feature-chart__table, .bl-comparison_table');


export {
  VerticalScrollArea,
  VerticalScrollProgress
};